<!-- @format -->

<ng-container *transloco="let t">
  @if (!completionMethods || completionMethods.length === 0) {
    <div>{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.NO_COMPLETION_METHODS") }}</div>
  }
  @if (assessmentItemsById) {
    <div>
      @if (completionMethods?.length > 0) {
        <table class="sis-table table-completion-method-matrix" [attr.aria-label]="t('COMPLETION_METHOD_MATRIX')">
          <thead>
            <tr>
              @for (completionMethod of completionMethods; track completionMethod; let cmIndex = $index) {
                <th
                  [class.is-highlighted]="highlightedCompletionMethodIndex === cmIndex"
                  class="col-completion-method-matrix-completion-selection">
                  <button
                    type="button"
                    class="non-button completion-method-container"
                    [attr.data-cy]="'completion-method-button-' + completionMethod.localId"
                    (click)="highlightCompletionMethod(cmIndex)">
                    <span
                      class="completion-method-header"
                      [attr.aria-label]="
                        t('ARIA_LABEL.VIEW_COMPLETION_METHOD_INFO') +
                        ' ' +
                        t('STUDIES.COURSE_UNITS_COMPLETION_METHODS.METHOD') +
                        ' ' +
                        (cmIndex + 1)
                      ">
                      {{ t("STUDIES.COURSE_UNITS_COMPLETION_METHODS.METHOD") }} {{ cmIndex + 1 }}
                    </span>
                    <sis-tiny-badge variant="secondary">
                      {{
                        t(
                          "STUDIES.COURSE_UNITS_COMPLETION_METHODS.COMPLETION_METHOD.STUDY_TYPE." +
                            (completionMethod.studyType === "OPEN_UNIVERSITY_STUDIES" ? "OPEN_UNIVERSITY_STUDIES" : "DEGREE_STUDIES")
                        )
                      }}
                    </sis-tiny-badge>
                  </button>
                </th>
              }
              <th class="completion-method-table-title">
                <h4>{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.ASSESSMENT_ITEM_HEADER") }}</h4>
              </th>
              <th class="completion-method-table-title">
                <h4>{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.COURSE_UNIT_REALISATIONS") }}</h4>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (assessmentItemId of orderedAssessmentItemIds; track assessmentItemId; let rowIndex = $index) {
              <tr
                [class.highlighted-completion-methods]="
                  completionMethodContainsAssessmentItemId(highlightedCompletionMethodIndex, assessmentItemId)
                "
                [class.is-selected]="isAssessmentItemSelected(rowIndex)"
                class="col-completion-method-matrix-assessment-item">
                @for (completionMethod of completionMethods; track completionMethod; let colIndex = $index) {
                  <td
                    class="col-completion-method-matrix-completion-selection"
                    [class.is-highlighted]="highlightedCompletionMethodIndex === colIndex">
                    @if (completionMethodContainsAssessmentItemId(colIndex, assessmentItemId)) {
                      <sis-icon icon="dot"></sis-icon>
                    }
                  </td>
                }
                <td class="assessment-items">
                  {{ assessmentItemsById[assessmentItemId] | assessmentItemNameInCourseUnitContext: courseUnit | localizedString }}
                  ({{ assessmentItemsById[assessmentItemId].credits | creditRange }})
                </td>
                <td class="course-unit-realisations">
                  @if (courseUnitRealisationsReady) {
                    @for (
                      courseUnitRealisation of getCourseUnitRealisationsForAssessmentItem(assessmentItemsById[assessmentItemId]);
                      track courseUnitRealisation
                    ) {
                      <span class="course-unit-realisations-list">
                        @if (completionMethodContainsAssessmentItemId(highlightedCompletionMethodIndex, assessmentItemId)) {
                          <sis-button [link]="true" (clicked)="navigateToCurSection(courseUnitRealisation)">
                            {{ courseUnitRealisation | courseUnitRealisationFullName | localizedString }}
                          </sis-button>
                        }
                        @if (!completionMethodContainsAssessmentItemId(highlightedCompletionMethodIndex, assessmentItemId)) {
                          {{ courseUnitRealisation | courseUnitRealisationFullName | localizedString }}
                        }
                        <sis-cur-flow-state-badge
                          [courseUnitRealisation]="courseUnitRealisation"
                          [hidePublishDate]="true"></sis-cur-flow-state-badge>
                      </span>
                    }
                    @if (getCourseUnitRealisationsForAssessmentItem(assessmentItemsById[assessmentItemId])?.length === 0) {
                      <span class="guidance">
                        {{ t("STUDIES.COURSE_UNIT_INFO_MODAL.NO_COURSE_UNIT_REALISATIONS") }}
                      </span>
                    }
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  }
  @if (completionMethods?.length > 0 && assessmentItemsById) {
    <div class="completion-method-info-container">
      <h2>{{ t("STUDIES.COURSE_UNITS_COMPLETION_METHODS.METHOD_LONG", { n: highlightedCompletionMethodIndex + 1 }) }}</h2>
      <sis-completion-method-assessment-item-info
        [completionMethod]="highlightedCompletionMethod"
        [language]="language"
        [useLocalizationFallback]="false"
        [showEmptyFields]="true">
      </sis-completion-method-assessment-item-info>
      <h2>{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.ASSESSMENT_ITEMS") }}</h2>
      @if (completionMethodAssessmentItems?.length === 0) {
        <div class="form-group-mimic">
          <ng-container *ngTemplateOutlet="noContent"></ng-container>
        </div>
      }
      @for (assessmentItem of completionMethodAssessmentItems; track assessmentItem) {
        <div>
          <sis-expandable
            [level]="3"
            [title]="
              (assessmentItem | assessmentItemNameInCourseUnitContext: courseUnit | localizedString) +
              ' ' +
              (assessmentItem.credits | creditRange)
            "
            [closed]="!isAssessmentItemExpandedById[assessmentItem.id]"
            (closedChange)="toggleAssessmentItem($event, assessmentItem.id)">
            <ng-template sisExpandableContent>
              <div class="row">
                <div class="col-12 col-md-6 form-group-mimic">
                  <h4>{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.NAME_SPECIFIER") }}</h4>
                  <p class="form-control-static">{{ assessmentItem.nameSpecifier | localizedString }}</p>
                </div>
                <div class="col-12 col-md-6 form-group-mimic">
                  <h4>{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.TYPE") }}</h4>
                  <p class="form-control-static">{{ assessmentItem.assessmentItemType | codeLocalizedName | async }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6 form-group-mimic">
                  <h4>{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.POSSIBLE_ATTAINMENT_LANGUAGES") }}</h4>
                  @for (languageUrn of assessmentItem.possibleAttainmentLanguages; track languageUrn) {
                    <p class="form-control-static">{{ languageUrn | codeLocalizedName | async }}</p>
                  }
                  @if (assessmentItem.possibleAttainmentLanguages?.length === 0) {
                    <p class="form-control-static">
                      <ng-container *ngTemplateOutlet="noContent"></ng-container>
                    </p>
                  }
                </div>
                <div class="col-12 col-md-6 form-group-mimic">
                  <h4>{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.STUDY_FORMAT") }}</h4>
                  <p class="form-control-static">
                    <sis-course-unit-info-modal-text-field
                      [localizedMarkupStringValue]="assessmentItem.studyFormat"
                      [language]="language"></sis-course-unit-info-modal-text-field>
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6 form-group-mimic">
                  <h4>{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.LEARNING_MATERIAL") }}</h4>
                  <p class="form-control-static">
                    <sis-course-unit-info-modal-text-field
                      [localizedMarkupStringValue]="assessmentItem.learningMaterial"
                      [language]="language"></sis-course-unit-info-modal-text-field>
                  </p>
                </div>
                <div class="col-12 col-md-6 form-group-mimic">
                  <h4>{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.LITERATURE") }}</h4>
                  @if (assessmentItem.literature?.length > 0) {
                    @for (item of assessmentItem.literature; track item) {
                      <sis-markup-string-view [content]="item | literature"> </sis-markup-string-view>
                    }
                  } @else {
                    <span class="sis-placeholder">
                      <sis-icon icon="alert-fill-attention"></sis-icon
                      >{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN") }}
                    </span>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6 form-group-mimic">
                  <h4>{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.CONTENT_DESCRIPTION") }}</h4>
                  <p class="form-control-static">
                    <sis-course-unit-info-modal-text-field
                      [localizedMarkupStringValue]="assessmentItem.contentDescription"
                      [language]="language"></sis-course-unit-info-modal-text-field>
                  </p>
                </div>
                <div class="col-12 col-md-6 form-group-mimic">
                  <h4>{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.GRADING") }}</h4>
                  <p class="form-control-static">
                    <sis-course-unit-info-modal-text-field
                      [localizedMarkupStringValue]="assessmentItem.grading"
                      [language]="language"></sis-course-unit-info-modal-text-field>
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6 form-group-mimic">
                  <h4>{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.STUDY_FIELD") }}</h4>
                  <p class="form-control-static">{{ assessmentItem.studyField | codeLocalizedName | async }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-12 teacher form-group-mimic">
                  <h4>{{ t("STUDIES.COURSE_UNIT_ASSESSMENT_ITEMS.RESPONSIBILITY_INFOS") }}</h4>
                  <sis-module-responsibility-info
                    [responsibilityInfos]="assessmentItem.responsibilityInfos"
                    [language]="language"></sis-module-responsibility-info>
                  @if (assessmentItem.responsibilityInfos?.length === 0) {
                    <p class="form-group-mimic form-control-static">
                      <ng-container *ngTemplateOutlet="noContent"></ng-container>
                    </p>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6 form-group-mimic">
                  <sis-responsible-organisation-info [organisations]="assessmentItem.organisations"></sis-responsible-organisation-info>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h4>{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.COURSE_UNIT_REALISATIONS") }}</h4>
                  @for (courseUnitRealisation of getCourseUnitRealisationsForAssessmentItem(assessmentItem); track courseUnitRealisation) {
                    <div id="{{ courseUnitRealisation.id }}">
                      <sis-expandable
                        [variant]="'naked-dotted'"
                        [closed]="!isCourseUnitRealisationExpandedById[courseUnitRealisation.id]"
                        (closedChange)="toggleCourseUnitRealisation($event, courseUnitRealisation.id)"
                        [title]="courseUnitRealisation | courseUnitRealisationFullName | localizedString"
                        [level]="5">
                        @if (courseUnitRealisation.flowState === "CANCELLED" || courseUnitRealisation.flowState === "ARCHIVED") {
                          <ng-template sisExpandableCustomTitle>
                            <sis-tiny-badge variant="secondary">{{
                              "FLOW_STATE." + courseUnitRealisation.flowState | translate
                            }}</sis-tiny-badge>
                          </ng-template>
                        }
                        <ng-template sisExpandableContent>
                          <sis-course-unit-info-modal-course-unit-realisation
                            [courseUnitRealisation]="courseUnitRealisation"
                            [language]="language"></sis-course-unit-info-modal-course-unit-realisation>
                        </ng-template>
                      </sis-expandable>
                    </div>
                  }
                  @if (getCourseUnitRealisationsForAssessmentItem(assessmentItem)?.length === 0) {
                    <p class="guidance">
                      {{ t("STUDIES.COURSE_UNIT_INFO_MODAL.NO_COURSE_UNIT_REALISATIONS") }}
                    </p>
                  }
                </div>
              </div>
            </ng-template>
          </sis-expandable>
        </div>
      }
    </div>
  }

  <ng-template #noContent>
    <span class="sis-placeholder">
      <sis-icon icon="alert-fill-attention"></sis-icon>{{ t("SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN") }}
    </span>
  </ng-template>
</ng-container>
